const constants = {
  mobileBreakpoint: 768,
  readMoreMinMobile: 400,
  readMoreMinDesktop: 800,
};

export default constants;
